"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TYPES_CONST = exports.SORT_ORDER_CONST = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TriangleUpIcon = _interopRequireDefault(require("../Icons/TriangleUpIcon"));

var _TriangleDownIcon = _interopRequireDefault(require("../Icons/TriangleDownIcon"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SORT_ORDER_CONST = {
  ASCEND: 'ascend',
  DESCEND: 'descend',
  NONE: 'none'
};
exports.SORT_ORDER_CONST = SORT_ORDER_CONST;
var TYPES_CONST = {
  THREE_STATES: '3states',
  TWO_STATES: '2states'
}; // eslint-disable-next-line valid-jsdoc

/**
 * Sorter is a component most often used on table column header
 * to toggle sort.
 */

exports.TYPES_CONST = TYPES_CONST;

var Sorter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Sorter, _React$Component);

  function Sorter(props) {
    var _this;

    _classCallCheck(this, Sorter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sorter).call(this, props));

    _this.handleOnClick = function (sortOrder) {
      var newSortOrder = sortOrder; // If for example 'ascend' is active then clicking on it again
      // will make it inactive.

      if (sortOrder === _this.state.sortOrder) {
        newSortOrder = SORT_ORDER_CONST.NONE;
      }

      _this.setSortOrderState(newSortOrder);
    };

    _this.toggleSortOrder = function () {
      var nextSortOrder;

      if (_this.props.type === TYPES_CONST.TWO_STATES) {
        switch (_this.state.sortOrder) {
          case SORT_ORDER_CONST.ASCEND:
            nextSortOrder = SORT_ORDER_CONST.DESCEND;
            break;

          case SORT_ORDER_CONST.DESCEND:
          default:
            nextSortOrder = SORT_ORDER_CONST.ASCEND;
        }
      } else {
        switch (_this.state.sortOrder) {
          case SORT_ORDER_CONST.ASCEND:
            nextSortOrder = SORT_ORDER_CONST.NONE;
            break;

          case SORT_ORDER_CONST.NONE:
            nextSortOrder = SORT_ORDER_CONST.DESCEND;
            break;

          case SORT_ORDER_CONST.DESCEND:
          default:
            nextSortOrder = SORT_ORDER_CONST.ASCEND;
        }
      }

      _this.setSortOrderState(nextSortOrder);
    };

    _this.state = {
      sortOrder: _this.props.sortOrder
    };
    return _this;
  }

  _createClass(Sorter, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        sortOrder: nextProps.sortOrder
      });
    }
    /**
     * Handler for when the ascend/descend icon is clicked
     * @param {string} sortOrder - See Sorter.PropTypes for the
     *   proper string.
     */

  }, {
    key: "setSortOrderState",

    /**
     * Set new state and notify onSortOrderChanged callback property
     * if any.
     * @param {string} newSortOrder - one of SORT_ORDER_CONST.XXX
     */
    value: function setSortOrderState(newSortOrder) {
      this.setState({
        sortOrder: newSortOrder
      });

      if (typeof this.props.onSortOrderChanged === 'function') {
        this.props.onSortOrderChanged(newSortOrder);
      }
    }
    /**
     * Toggle to the next SortOrder state.
     */

  }, {
    key: "renderToggleStates",

    /**
     * For props.type = 2states | 3states this is the returned
     * element
     * @param {string} classNames - class name for the element.
     * @param {object} props - props for the element.
     * @returns {element} - react element.
     */
    value: function renderToggleStates(classNames, props) {
      var ascColor = this.state.sortOrder === SORT_ORDER_CONST.ASCEND ? 'gray-1' : 'light-gray-2';
      var descColor = this.state.sortOrder === SORT_ORDER_CONST.DESCEND ? 'gray-1' : 'light-gray-2';
      var _this$props = this.props,
          upIconProps = _this$props.upIconProps,
          downIconProps = _this$props.downIconProps;
      return _react.default.createElement("div", _extends({
        className: classNames
      }, props, {
        onClick: this.toggleSortOrder
      }), _react.default.createElement("span", {
        className: "icon-container"
      }, _react.default.createElement(_TriangleUpIcon.default, _extends({
        color: ascColor,
        size: "small"
      }, upIconProps))), _react.default.createElement("span", {
        className: "icon-container"
      }, _react.default.createElement(_TriangleDownIcon.default, _extends({
        color: descColor,
        size: "small"
      }, downIconProps))));
    }
  }, {
    key: "render",
    value: function render() {
      // onSortOrderChanged is being stripped out because
      // renderXXX() doesn't need it.  See setSortOrderState
      // For where it is being used.
      // eslint-disable-next-line no-unused-vars
      var _this$props2 = this.props,
          className = _this$props2.className,
          sortOrder = _this$props2.sortOrder,
          onSortOrderChanged = _this$props2.onSortOrderChanged,
          upIconProps = _this$props2.upIconProps,
          downIconProps = _this$props2.downIconProps,
          type = _this$props2.type,
          props = _objectWithoutProperties(_this$props2, ["className", "sortOrder", "onSortOrderChanged", "upIconProps", "downIconProps", "type"]);

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      var classNames = (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-sorter"), "sort-order-".concat(this.state.sortOrder), className);

      switch (type) {
        case TYPES_CONST.TWO_STATES:
        case TYPES_CONST.THREE_STATES:
          return this.renderToggleStates(classNames, props);

        default:
          return this.renderToggleStates(classNames, props);
      }
    }
  }]);

  return Sorter;
}(_react.default.Component);

exports.default = Sorter;
Sorter.SORT_ORDER_CONST = SORT_ORDER_CONST;
Sorter.defaultProps = {
  sortOrder: 'ascend',
  type: '2states'
};
Sorter.propTypes = {
  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Control the display of the Sorter format.
   */
  sortOrder: _propTypes.default.oneOf(['ascend', 'descend', 'none']),

  /**
   * Three style type for toggling the sorter
   * 2states: ascend -> descend, descend -> ascend
   * 3states: ascend -> none -> descend -> back to ascend.
   */
  type: _propTypes.default.oneOf(['2states', '3states']),

  /**
   * Callback when sortOrder is changed.
   * onSortOrderChanged(sortOrder)
   */
  onSortOrderChanged: _propTypes.default.func,

  /**
   * Props to pass to up icon
   */
  upIconProps: _propTypes.default.object,

  /**
   * Props to pass to down icon
   */
  downIconProps: _propTypes.default.object
};